export default __webpack_public_path__ + "static/lines-bg-61a88424f46cd9b60a44ad311b244d24.svg";